<template>
  <div class="flex flex-col items-center justify-center" :class="props.full
      ? 'fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-50/80'
      : 'bg-white/90 w-full h-full'
    ">
    <div :class="props.full ? 'absolute' : ''" class="flex flex-col mx-auto justify-center items-center">
      <div class="h-full w-full">
        <NuxtIcon name="loading" class="animate-spin" viewBox="0 0 24 24" filled
          :class="props.full ? 'text-[100px] text-gray-400' : 'text-[80px] text-primary'" />
      </div>
      <div class="mt-5" v-if="props.button">
        <button type="button" class="py-3 px-5 rounded-md bg-fuchsia-700 text-white font-bold" @click="buttonfunction">
          {{ props.buttontext }}
        </button>
      </div>
    </div>
  </div>

  <!-- <div class="flex flex-col items-center justify-center" :class="props.full
    ? 'fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-50/100'
    : 'absolute bg-white/90 w-full h-full'
    ">
    <div :class="props.full ? 'absolute' : ''" class="flex flex-col mx-auto justify-center items-center">
      <div class="h-full w-full">
        <NuxtIcon name="loading" class="animate-spin" viewBox="0 0 24 24" filled
          :class="props.full ? 'text-[100px] text-gray-400' : 'text-[80px] text-primary'" />
      </div>
      <div class="mt-5" v-if="props.button">
        <button type="button" class="py-3 px-5 rounded-md bg-fuchsia-700 text-white font-bold" @click="buttonfunction">
          {{ props.buttontext }}
        </button>
      </div>
    </div>
  </div> -->
</template>

<script setup>
const props = defineProps({
  full: {
    type: Boolean,
    default: false,
  },
  modal: {
    type: Boolean,
    default: false,
  },
  reload: {
    type: Boolean,
    default: true,
  },
  button: {
    type: Boolean,
    default: false,
  },
  buttontext: {
    type: String,
  },
  buttonfunction: {
    type: Function,
  },
});
</script>

<style></style>
